import React from "react";
import VerticalPage from "@/verticals/VerticalPage";
import { servicesPublicsData } from "@/verticals/verticalData";

export default function ServicesPublicsPage() {
  return <VerticalPage data={servicesPublicsData} />;
}
